import { abortableFetch } from '../clientFetch';
/*
 * Doctor autocomplete
 */

export const doctorAutocomplete = (input, lat, lon) => {
  return abortableFetch(
    `/autocomplete/doctor`,
    {
      params: {
        input,
        lat,
        lon,
      },
    },
    'doctorAutocompleteController',
  );
};
